import { useReduxState } from 'hooks';
import { Link } from 'components/common';
import { Icon } from 'components/common/icons';

import type { HomePageModule } from 'shared-types';

interface Props {
  link: HomePageModule['data']['links'][0];
}

const HomeQuickLinksLink = ({ link }: Props) => {
  const { serverConfig, theme } = useReduxState();

  const WrapperElement = ({ children }) =>
    link.url.startsWith(serverConfig.adminUrl) ? (
      <Link
        href={link.url}
        linkColor="inherit"
        style={{ textDecoration: 'none' }}
      >
        {children}
      </Link>
    ) : (
      <a
        href={link.url}
        rel="noopener noreferrer"
        style={{ color: 'inherit', cursor: 'pointer', textDecoration: 'none' }}
        target="_blank"
      >
        {children}
      </a>
    );

  return (
    <WrapperElement>
      <div className="content">
        <div className="icon">
          <Icon icon="link" />
        </div>
        <div className="info">
          <div className="title">{link.title}</div>

          {link.description ? (
            <div className="description">{link.description}</div>
          ) : null}
        </div>

        <style jsx>{`
          .content {
            align-items: normal;
            background-color: white;
            border-radius: 10px;
            box-shadow: ${theme.cardBoxShadow};
            cursor: pointer;
            display: flex;
            flex-direction: row-reverse;
            gap: 10px;
            padding: 15px 20px;
            transition: box-shadow 0.3s;
          }
          .content:hover {
            box-shadow: ${theme.cardBoxShadowActive};
          }
          .icon {
            align-items: center;
            background-color: ${theme.lightGrey};
            border-radius: 40px;
            color: ${theme.textColorLight};
            display: flex;
            flex-grow: 0;
            flex-shrink: 0;
            font-size: 1.4rem;
            justify-content: center;
            height: 40px;
            width: 40px;
          }
          .info {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            flex-shrink: 1;
            justify-content: center;
          }
          .title {
            color: ${theme.textColor};
            font-size: 1.6rem;
            font-weight: 700;
          }
          .description {
            color: ${theme.textColorLight};
            font-size: 1.4rem;
            font-weight: 400;
            margin-top: 3px;
          }
        `}</style>
      </div>
    </WrapperElement>
  );
};

export default HomeQuickLinksLink;
